<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon color="primary">mdi-shield-account</v-icon>
        <span class="pl-2">Privacy Policy</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save" :loading="isSaving">
          {{ $t('actions.save') }}
          <v-icon right dark>mdi-content-save</v-icon>
        </v-btn>
        <v-btn class="mx-2" depressed color="success" @click="preview">
          Preview
          <v-icon right dark>mdi-eye</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <vue-element-loading :active="isLoading" />

        <div class="lang-switcher mb-4">
          <button class="lang-btn" :class="{ active: activeLang === 'sq' }" @click="switchLang('sq')">
            🇦🇱 Shqip
          </button>
          <button class="lang-btn" :class="{ active: activeLang === 'en' }" @click="switchLang('en')">
            🇬🇧 English
          </button>
        </div>

        <div v-if="!isLoading" class="editor-wrapper">
          <quill-editor
            v-if="activeLang === 'sq'"
            v-model="content.sq"
            :options="editorOptions"
            key="sq"
          ></quill-editor>
          <quill-editor
            v-if="activeLang === 'en'"
            v-model="content.en"
            :options="editorOptions"
            key="en"
          ></quill-editor>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  components: { VueElementLoading, quillEditor },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      activeLang: 'sq',
      content: { sq: '', en: '' },
      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean'],
          ],
        },
        placeholder: 'Shkruaj Privacy Policy këtu...',
      },
    }
  },
  mounted() {
    this.loadLang('sq')
    this.loadLang('en')
  },
  methods: {
    switchLang(lang) {
      this.activeLang = lang
    },
    loadLang(lang) {
      this.isLoading = true
      axios.get('/settings/privacy-policy', { params: { lang } })
        .then(res => { this.content[lang] = res.data.privacy || '' })
        .catch(() => {})
        .finally(() => { this.isLoading = false })
    },
    preview() {
      const routeData = this.$router.resolve({ name: 'privacy' })
      window.open(routeData.href, '_blank')
    },
    save() {
      this.isSaving = true
      axios.post('/settings/update-privacy-policy', { privacy: this.content[this.activeLang], lang: this.activeLang })
        .then(() => { this.$notify({ title: 'Sukses', text: 'Privacy Policy u ruajt (' + this.activeLang.toUpperCase() + ')!', type: 'success' }) })
        .catch(() => { this.$notify({ title: 'Gabim', text: 'Gabim gjatë ruajtjes', type: 'error' }) })
        .finally(() => { this.isSaving = false })
    },
  },
}
</script>

<style scoped>
.lang-switcher { display: flex; gap: 8px; }
.lang-btn {
  padding: 6px 18px;
  border-radius: 20px;
  border: 2px solid #e0e0e0;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  color: #666;
}
.lang-btn.active {
  border-color: #1976D2;
  background: #1976D2;
  color: #fff;
}
.lang-btn:hover:not(.active) { border-color: #1976D2; color: #1976D2; }
.editor-wrapper { border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; }
.editor-wrapper :deep(.ql-editor) { min-height: 500px; font-size: 15px; line-height: 1.7; }
.editor-wrapper :deep(.ql-toolbar) { border-bottom: 1px solid #e0e0e0; background: #fafafa; }
</style>
